import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import HomePageListContext from "../../../context/home-page-list/context";
import { getHomePageStatus, getHomePageType } from "../../../models/home-page-list/enum";
import { useLocation } from "react-router-dom";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";

interface IProps { }

const HomePagListFilter: React.FC<IProps> = () => {
    const { t } = useTranslation();
    const { actions, query } = useContext(HomePageListContext);

    const type = [1, 2, 3, 4, 5]
    const status = [1, 2]

    const location = useLocation();
    const [initialValues, setInitialValues] = useState<Record<string, any>>({});

    useEffect(() => {
        const filters = getFiltersFromURL();

        const initialValuesObj = {};
        filters.forEach((f) => {
            initialValuesObj[f.name] = f.value;
        });

        setInitialValues(initialValuesObj);
    }, [location.search]);

    return (
        <Form
            formId="home-page-list-filter"
            defaultValues={initialValues}
            onSubmit={(data) => {
                const keyword = getKeywordFromURL();
                const filter: any = {
                    page: INITIAL_PAGE,
                    perPage: query?.perPage,
                    keyword: keyword,
                    filters: [
                        data?.status
                            ? {
                                name: "status",
                                value: data.status,
                                operation: "eq",
                            }
                            : undefined,
                        data?.type
                            ? {
                                name: "type",
                                value: data.type,
                                operation: "eq",
                            }
                            : undefined,
                    ].filter((f) => f),
                };

                const queryString = filtersToQueryString(filter.filters);
                window.history.replaceState(null, "", `?${queryString}`);
                addSearchToURL(keyword);
                actions.setQuery(filter);
            }}
        >
            <Row justify={"start"} gutter={[10, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                    <FieldBuilder
                        name="status"
                        label={`${t("status")}`}
                        width="large"
                        input={{
                            type: "select",
                            loading: false,
                            options: status?.map((state, index) => {
                                return {
                                    key: index,
                                    label: t(getHomePageStatus(state)),
                                    value: state,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                    <FieldBuilder
                        name="type"
                        label={`${t("type")}`}
                        width="large"
                        input={{
                            type: "select",
                            loading: false,
                            options: type?.map((type, index) => {
                                return {
                                    key: index,
                                    label: t(getHomePageType(type)),
                                    value: type,
                                };
                            }),
                        }}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default HomePagListFilter;
